import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { LoaderObject } from '../models/loader-object.model';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private subjects: BehaviorSubject<LoaderObject>[] = [];

  public createLoader(loaderId: string, show?: boolean): Observable<LoaderObject> {
    let subject = new BehaviorSubject<LoaderObject>(null);
    if (loaderId) {
      subject = this.subjects.find(s => s.value.loaderId === loaderId);
      if (!subject) {
        subject = new BehaviorSubject<LoaderObject>({ loaderId, show });
        this.subjects.push(subject);
      }
      if (subject.value && subject.value.show) {
        subject.next({ loaderId, show: true });
      }
    }
    return subject.asObservable();
  }

  public destroyLoader(loaderId: string) {
    this.subjects = this.subjects.filter(s => s.value.loaderId !== loaderId);
  }

  public showLoader(loaderId: string) {
    if (loaderId) {
      let subject = this.subjects.find(s => s.value.loaderId === loaderId);
      !subject ? this.createLoader(loaderId, true) : subject.next({ loaderId, show: true });
    }
  }

  public dismissLoader(loaderId: string) {
    if (loaderId) {
      const subject = this.subjects.find(s => s.value.loaderId === loaderId);
      if (subject) { subject.next({ loaderId, show: false }); }
    }
  }
}
